import { FormBuilderNotificationEmail } from './form-builder-notification-email.model';

export class FormBuilderCommunicationOptions {
  public NotificationEmails: Array<FormBuilderNotificationEmail>;
  public ConfirmationEmailMessage: string;
  public AssociationNameOverride: string;

  public constructor() {
    this.NotificationEmails = [];
    this.ConfirmationEmailMessage = '';
    this.AssociationNameOverride = '';
  }
}
